import {createAction, props} from '@ngrx/store';

export class AppNavigationActions {
  private static readonly prefix = '[App Navigation] ';

  // Button enabled/disabled
  public static enableButton = createAction(this.prefix + 'Enable Button.', props<{buttonId: string}>());

  public static disableButton = createAction(this.prefix + 'Disable Button.', props<{buttonId: string}>());

  public static setButtonEnabled = createAction(
    this.prefix + 'Set Button Enabled.',
    props<{buttonId: string; enabled: boolean}>(),
  );

  // Button visibility
  public static showButton = createAction(this.prefix + 'Show Button.', props<{buttonId: string}>());

  public static hideButton = createAction(this.prefix + 'Hide Button.', props<{buttonId: string}>());

  public static setButtonVisibility = createAction(
    this.prefix + 'Set Button Visibility.',
    props<{buttonId: string; visible: boolean}>(),
  );

  // Domain-specific actions dispatched by buttons
  public static openFileUpload = createAction(this.prefix + 'Open File Upload.');

  public static openBelegmailDialog = createAction(this.prefix + 'Open Belegmail Dialog.');
}
